import {Route} from "@angular/router"
import {AuthGuard, SubscriptionGuard} from "@common/services/guards/guards.service"
import {MaterialEditorComponent} from "@material-editor/components/material-editor/material-editor.component"
import {MaterialDetailsComponent} from "@platform/components/materials/material-details/material-details.component"
import {MaterialExplorerComponent} from "@platform/components/materials/material-explorer/material-explorer.component"
import {TaskDetailsComponent} from "@platform/components/tasks/task-details/task-details.component"
import {TemplateDetailsComponent} from "@app/templates/template-details/template-details.component"
import {TemplateViewerDialogComponent} from "@common/components/dialogs/template-viewer-dialog/template-viewer-dialog.component"
import {MaterialsPageComponent} from "@pages/materials/materials-page.component"
import {TemplatesPageComponent} from "@app/templates/templates-page/templates-page.component"
import {TemplateEditorComponent} from "@template-editor/components/template-editor/template-editor.component"
import {TextureEditorComponent} from "@app/textures/texture-editor/texture-editor.component"
import {MaterialEditorEntryMode} from "@app/material-editor/types/entry-mode"

export const templateRouteBase = {
    component: TemplatesPageComponent,
    canActivate: [AuthGuard, SubscriptionGuard],
    children: [
        {path: ":itemId", component: TemplateDetailsComponent, canActivate: [AuthGuard, SubscriptionGuard]},
        {
            path: ":templateId/revisions/add",
            component: TemplateEditorComponent,
            data: {closeNavigationPath: "../../../"},
            canActivate: [AuthGuard, SubscriptionGuard],
        },
        {
            path: ":templateId/revisions/:templateRevisionId/edit",
            component: TemplateEditorComponent,
            data: {closeNavigationPath: "../../../../"},
            canActivate: [AuthGuard, SubscriptionGuard],
        },
        {path: ":templateId/view", component: TemplateViewerDialogComponent, canActivate: [AuthGuard, SubscriptionGuard]},
    ],
} satisfies Omit<Route, "path" | "title" | "data">

export const materialsRouteBase = {
    component: MaterialsPageComponent,
    canActivate: [AuthGuard, SubscriptionGuard],
    children: [
        {
            path: "create",
            data: {createDialog: true},
            canActivate: [AuthGuard, SubscriptionGuard],
            children: [],
        },
        {
            path: "explorer",
            component: MaterialExplorerComponent,
            canActivate: [AuthGuard, SubscriptionGuard],
        },
        {
            path: ":itemId",
            component: MaterialDetailsComponent,
            canActivate: [AuthGuard, SubscriptionGuard],
            children: [
                {
                    path: "edit/:revisionId",
                    component: MaterialEditorComponent,
                    data: {closeNavigationPath: "../../", entryMode: MaterialEditorEntryMode.Edit},
                    canActivate: [AuthGuard, SubscriptionGuard],
                },
                {
                    path: "setup/:textureSetRevisionId",
                    component: MaterialEditorComponent,
                    data: {closeNavigationPath: "../../", entryMode: MaterialEditorEntryMode.Setup},
                    canActivate: [AuthGuard, SubscriptionGuard],
                },
                {
                    path: "setup",
                    component: MaterialEditorComponent,
                    data: {closeNavigationPath: "../", entryMode: MaterialEditorEntryMode.Setup},
                    canActivate: [AuthGuard, SubscriptionGuard],
                },
                {
                    path: "preview/:keyForKeyValueStore",
                    component: MaterialEditorComponent,
                    canActivate: [AuthGuard, SubscriptionGuard],
                },
                {
                    path: "tasks/:taskId",
                    component: TaskDetailsComponent,
                    canActivate: [AuthGuard, SubscriptionGuard],
                    data: {closeNavigationPath: "../../"},
                },
                {
                    path: "set-revisions/:textureSetRevisionId",
                    component: TextureEditorComponent,
                    data: {closeNavigationPath: "../../", closeQueryParamOverride: {textureType: null}},
                    canActivate: [AuthGuard, SubscriptionGuard],
                },
            ],
        },
    ],
} satisfies Omit<Route, "path" | "title" | "data">
